export const buildVisualizationVariables = (
  visualizationVariables = [],
  siteVariables = [],
  stateSets = []
) =>
  visualizationVariables.map((visualizationVariable) => {
    const siteVariable = siteVariables.find(({ id }) => id === visualizationVariable.id);
    // siteVariable.stateset can be stale, use the live one from the statesets store if we have it
    const embeddedStateset = siteVariable?.stateset || visualizationVariable.stateset;
    const liveStateset = embeddedStateset && stateSets.find(({ id }) => id === embeddedStateset.id);

    return {
      ...visualizationVariable,
      name: siteVariable?.name,
      source: siteVariable?.source,
      itemDesignation: siteVariable?.itemDesignation,
      stateset: liveStateset || embeddedStateset,
    };
  });
